import { FixedObject } from "gatsby-image";
import { Locale } from "../../../../config/sites-and-locales";
import { getFacebookAppId } from "../../../utilities/environment-variables";

interface GetOpenGraphTagsArgs {
  canonicalUrl: string;
  pageDescription: string;
  pageImage?: FixedObject;
  locale: Locale;
  title: string;
}

export function getOpenGraphTags({
  canonicalUrl,
  locale,
  pageDescription,
  pageImage,
  title,
}: GetOpenGraphTagsArgs) {
  const fbAppId = { property: "fb:app_id", content: getFacebookAppId() };
  const ogDescription = {
    property: "og:description",
    content: pageDescription,
  };
  const ogLocale = { property: "og:locale", content: locale };
  const ogSiteName = { property: "og:site_name", content: "TaskRabbit" };
  const ogTitle = { property: "og:title", content: title };
  const ogType = { property: "og:type", content: "website" };
  const ogUrl = { property: "og:url", content: canonicalUrl };
  const tags = [
    fbAppId,
    ogDescription,
    ogLocale,
    ogSiteName,
    ogTitle,
    ogType,
    ogUrl,
  ];
  if (pageImage != null) {
    if (pageImage.src == null) {
      throw Error("pageImage.src is null");
    }
    if (pageImage.height == null) {
      throw Error("pageImage.height is null");
    }
    if (pageImage.width == null) {
      throw Error("pageImage.width is null");
    }
    const ogImage = { property: "og:image", content: pageImage.src };
    const ogImageHeight = {
      property: "og:image:height",
      content: pageImage.height.toString(),
    };
    const ogImageWidth = {
      property: "og:image:width",
      content: pageImage.width.toString(),
    };
    tags.push(ogImage);
    tags.push(ogImageHeight);
    tags.push(ogImageWidth);
  }
  return tags;
}
